export default "__VITE_ASSET__CqfW3iSP__"